<template>
  <div class="content">
    <base-header :choose-index="5" ref="header_content"></base-header>
    <div class="middle_content">
      <!-- post -->
      <div class="middle_content-post" v-bgImg="require('@@/assets/img/westa/service/fwwl.png')"></div>
      <!-- 分类 -->
      <div class="middle_content-classify">
        <div class="middle_content-classify-item" @click="chooseTag(0)">
          <div class="middle_content-classify-pic" v-bgImg="require('@@/assets/img/westa/service/产品保修 2.png')" v-show="tag === '产品报修'"></div>
          <div class="middle_content-classify-pic" v-bgImg="require('@@/assets/img/westa/service/产品保修-2.png')" v-show="tag != '产品报修'"></div>
          <div class="middle_content-classify-text" :class="{ choose: tag != '产品报修' }">产品报修</div>
        </div>
        <div class="middle_content-classify-item" @click="chooseTag(1)">
          <div class="middle_content-classify-pic" v-bgImg="require('@@/assets/img/westa/service/使用指南 2.png')" v-show="tag === '使用指南'"></div>
          <div class="middle_content-classify-pic" v-bgImg="require('@@/assets/img/westa/service/使用指南-2.png')" v-show="tag != '使用指南'"></div>
          <div class="middle_content-classify-text" :class="{ choose: tag != '使用指南' }">使用指南</div>
        </div>
      </div>
      <!-- tips -->
      <div class="middle_content-tip">
        <div v-show="tag === '产品报修'">尊敬的用户，请您填写以下信息提交后我们将及时安排处理，谢谢</div>
        <!-- <div v-show="tag === '使用指南'">请选择您的商品</div> -->
      </div>
      <!-- 产品分类 -->
      <!-- <div class="middle_content-product">
        <div class="middle_content-product-item" @click="chooseProduct = '台式电烤箱'">
          <div
            class="middle_content-product-item-pic"
            v-bgImg="require('@@/assets/img/westa/home/icon01.png')"
            v-show="chooseProduct === '台式电烤箱'"
          ></div>
          <div
            class="middle_content-product-item-pic"
            v-bgImg="require('@@/assets/img/westa/home/icon01-2.png')"
            v-show="chooseProduct != '台式电烤箱'"
          ></div>
          <div>台式电烤箱</div>
        </div>
        <div class="middle_content-product-item" @click="chooseProduct = '嵌入式烤箱'">
          <div
            class="middle_content-product-item-pic"
            v-bgImg="require('@@/assets/img/westa/home/icon02.png')"
            v-show="chooseProduct === '嵌入式烤箱'"
          ></div>
          <div
            class="middle_content-product-item-pic"
            v-bgImg="require('@@/assets/img/westa/home/icon02-2.png')"
            v-show="chooseProduct != '嵌入式烤箱'"
          ></div>
          <div>嵌入式烤箱</div>
        </div>
        <div class="middle_content-product-item" @click="chooseProduct = '蒸烤箱'">
          <div
            class="middle_content-product-item-pic"
            v-bgImg="require('@@/assets/img/westa/home/icon03.png')"
            v-show="chooseProduct === '蒸烤箱'"
          ></div>
          <div
            class="middle_content-product-item-pic"
            v-bgImg="require('@@/assets/img/westa/home/icon03-2.png')"
            v-show="chooseProduct != '蒸烤箱'"
          ></div>
          <div>蒸烤箱</div>
        </div>
        <div class="middle_content-product-item" @click="chooseProduct = '厨师机'">
          <div
            class="middle_content-product-item-pic"
            v-bgImg="require('@@/assets/img/westa/home/icon04.png')"
            v-show="chooseProduct === '厨师机'"
          ></div>
          <div
            class="middle_content-product-item-pic"
            v-bgImg="require('@@/assets/img/westa/home/icon04-2.png')"
            v-show="chooseProduct != '厨师机'"
          ></div>
          <div>厨师机</div>
        </div>
        <div class="middle_content-product-item" @click="chooseProduct = '烘焙工具'">
          <div
            class="middle_content-product-item-pic"
            v-bgImg="require('@@/assets/img/westa/home/icon05.png')"
            v-show="chooseProduct === '烘焙工具'"
          ></div>
          <div
            class="middle_content-product-item-pic"
            v-bgImg="require('@@/assets/img/westa/home/icon05-2.png')"
            v-show="chooseProduct != '烘焙工具'"
          ></div>
          <div>烘焙工具</div>
        </div>
      </div>-->
      <div class="middle_content-down" v-show="tag === '产品报修'">
        <div class="middle_content-down-flex">
          <div class="middle_content-down-item margin-right">
            <div class="middle_content-down-item-text">请填写你的产品故障</div>
            <div class="middle_content-down-item-input">
              <el-input placeholder="型号" v-model="product.fix_model"></el-input>
            </div>
            <el-input class="middle_content-down-item-input1" placeholder="故障描述" type="textarea" :rows="5" resize="none" v-model="product.fix_content"></el-input>
          </div>
          <div class="middle_content-down-item">
            <div class="middle_content-down-item-text">请填写你的联系方式</div>
            <el-input class="middle_content-down-item-input" placeholder="姓名" v-model="user.fix_nick"></el-input>
            <el-input class="middle_content-down-item-input" placeholder="电话" v-model="user.fix_phone"></el-input>
            <el-input class="middle_content-down-item-input" placeholder="邮箱" v-model="user.fix_email"></el-input>
          </div>
        </div>
        <div class="middle_content-down-btn">
          <el-button type="info" class="middle_content-down-btn-item color" @click="reset">重置</el-button>
          <el-button type="primary" class="middle_content-down-btn-item" @click="submit">提交</el-button>
        </div>
      </div>
      <div class="middle_content-down1" v-show="tag === '使用指南'">
        <div class="middle_content-down1-left" style="overflow: hidden;">
          <div class="middle_content-down1-left-list">
            <div class="middle_content-down1-left-list-item" :class="{ 'middle_content-down1-left-list-item-active': chooseIndex === index }" v-for="(item, index) in content_online_syzl" :key="index" @click="showContent(index)">
              <div class="middle_content-down1-left-list-item-cir"></div>
              <div>{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="middle_content-down1-right" style="overflow: auto;">
          <div v-if="content_online_syzl.length">{{ content_online_syzl[chooseIndex].content }}</div>
        </div>
      </div>
    </div>
    <base-footer></base-footer>
  </div>
</template>

<script>
  import BaseHeader from "@@/components/westa/base-header";
  import BaseFooter from "@@/components/westa/base-footer";
  export default {
    data() {
      return {
        product: {},
        user: {},
        tag: "产品报修",
        chooseProduct: "",
        content_online_syzl: [],
        chooseIndex: 0,
      };
    },
    components: {
      BaseHeader,
      BaseFooter,
    },
    watch: {
      $route(to, from) {
        // 对路由变化作出响应...
        let tag = this.$route.query.tag;
        this.tag = tag;
        this.getInfo();
      },
    },
    created() {
      let tag = this.$route.query.tag;
      if (tag) {
        this.tag = tag;
      }

      this.getInfo();
    },
    mounted() {},
    methods: {
      getInfo() {
        let params = {};
        this.req
          .get(url_api_web_websiteContent_getWebsiteContent, this.qs.stringify(params))
          .then((result) => {
            this.content_online_syzl = JSON.parse(result.website_content.content_online_syzl);
          })
          .catch((error) => {});
      },
      chooseTag(index) {
        switch (index) {
          case 0:
            this.tag = "产品报修";
            break;
          case 1:
            this.tag = "使用指南";
            break;
        }
      },
      showContent(index) {
        this.chooseIndex = index;
      },
      reset() {
        this.product.fix_model = "";
        this.user.fix_nick = "";
        this.user.fix_phone = "";
        this.user.fix_email = "";
        this.product.fix_content = "";
      },
      submit() {
        let params = {
          fix_model: this.product.fix_model,
          fix_nick: this.user.fix_nick,
          fix_phone: this.user.fix_phone,
          fix_email: this.user.fix_email,
          fix_content: this.product.fix_content,
        };
        this.req
          .post(url_api_web_websiteFix_postWebsiteFix, this.qs.stringify(params))
          .then((result) => {
            this.utils.successMessage("提交成功");
            this.reset();
            // this.utils.errorMessage("error");
          })
          .catch((error) => {
            this.utils.errorMessage(error);
          });
      },
    },
  };
</script>

<style lang="less" scoped>
  .middle_content {
    padding-top: 64px;
    min-width: 1200px;
    &-post {
      width: 100%;
      height: 360px;
    }
    &-classify {
      width: 100%;
      height: 140px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #eee;
      &-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 36px;
        cursor: pointer;
      }
      &-pic {
        width: 40px;
        height: 40px;
      }
      &-text {
        font-size: 14px;
        text-align: center;
        margin-top: 24px;
        color: #181f99;
      }
    }
    &-tip {
      width: 1200px;
      margin: 48px auto;
      font-size: 24px;
      text-align: center;
      color: #666;
    }
    &-product {
      width: 1200px;
      height: 136px;
      margin: 0 auto;
      background: #f4f4f4;
      display: flex;
      align-items: center;
      justify-content: space-around;
      border: 1px solid #eee;
      box-sizing: border-box;
      &-item {
        font-size: 16px;
        color: #666;
        text-align: center;
        &-pic {
          width: 72px;
          height: 72px;
        }
      }
    }
    &-down {
      width: 1200px;
      height: 446px;
      border: 1px solid #eee;
      // border-top: 0;
      margin: 0 auto;
      padding: 30px 40px;
      box-sizing: border-box;
      &-flex {
        display: flex;
        // justify-content: space-between;
      }
      &-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        &-item {
          width: 176px;
          height: 54px;
          margin: 40px 32px;
        }
      }
      &-item {
        &-text {
          font-size: 18px;
          color: #000;
          margin-bottom: 36px;
        }
        &-input {
          width: 524px;
          height: 54px;
          margin-bottom: 20px;
        }
        &-input1 {
          width: 524px;
          height: 140px;
        }
      }
    }
    &-down1 {
      width: 1200px;
      height: 430px;
      background: #f4f4f4;
      margin: 20px auto;
      display: flex;
      &-left {
        width: 600px;
        height: 100%;
        padding: 20px 0 20px 20px;
        box-sizing: border-box;
        overflow: scroll;
        &-list {
          &-item {
            width: 100%;
            height: 60px;
            line-height: 60px;
            font-size: 18px;
            color: #666;
            display: flex;
            align-items: center;
            cursor: pointer;
            &-cir {
              width: 6px;
              height: 6px;
              background: #666;
              border-radius: 50%;
              margin: 0 10px;
            }
            &:hover {
              background: #e9e9ef;
              color: #181f99;
              .middle_content-down1-left-list-item-cir {
                background: #181f99;
              }
            }
            &-active {
              background: #e9e9ef;
              color: #181f99;
              .middle_content-down1-left-list-item-cir {
                background: #181f99;
              }
            }
          }
        }
      }
      &-right {
        width: 600px;
        height: 430px;
        overflow-y: scroll;
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: break-all;
        background: #e9e9ef;
        padding: 30px 20px;
        box-sizing: border-box;
        font-size: 16px;
      }
    }
  }
  .margin-right {
    margin-right: 64px;
  }
  .choose {
    color: #666;
  }
  .color {
    background: #7479c2;
  }
</style>
